import {css} from "@panda/css";

import {ListIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {getThumbnailLink} from "../../../../utils/get_thumbnail_link";
import {IVendorDetail} from "../../../types/IVendorDetail";

interface IProps {
    vendor: IVendorDetail;
}

export const VendorDetailReportModalContentDescription = (props: IProps) => {
    const {vendor} = props;

    return (
        <>
            <div className={subHeaderStyle}>
                <ListIcon size="3" />
                <Text variant="mini_header">INFORMACJE OGÓLNE</Text>
            </div>
            <div className={titleStyle}>
                <Image alt={`${vendor.name} logo`} src={getThumbnailLink(vendor.logo_url, 120, 90) ?? ""} width="120" height="90" />
                <div>
                    <Text variant="headline_2" strong>
                        {vendor.name}
                    </Text>
                    {vendor.headquarters && (
                        <Text variant="body_copy_1">
                            {vendor.headquarters.region.short_name}, {vendor.headquarters.address}
                        </Text>
                    )}
                </div>
            </div>
            <Text variant="body_copy_2" color="var(--colors-gray-800)" mb={3}>
                {vendor.description}
            </Text>
        </>
    );
};

const subHeaderStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
    mb: 4
});

const titleStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    mb: 3
});
import {css} from "@panda/css";

import {ListIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {getThumbnailLink} from "../../../../utils/get_thumbnail_link";
import {IVendorDetail} from "../../../types/IVendorDetail";

interface IProps {
    vendor: IVendorDetail;
}

export const VendorDetailReportModalContentDescription = (props: IProps) => {
    const {vendor} = props;

    return (
        <>
            <div className={subHeaderStyle}>
                <ListIcon size="3" />
                <Text variant="mini_header">INFORMACJE OGÓLNE</Text>
            </div>
            <div className={titleStyle}>
                <Image alt={`${vendor.name} logo`} src={getThumbnailLink(vendor.logo_url, 120, 90) ?? ""} width="120" height="90" />
                <div>
                    <Text variant="headline_2" strong>
                        {vendor.name}
                    </Text>
                    {vendor.headquarters && (
                        <Text variant="body_copy_1">
                            {vendor.headquarters.region.short_name}, {vendor.headquarters.address}
                        </Text>
                    )}
                </div>
            </div>
            <Text variant="body_copy_2" color="var(--colors-gray-800)" mb={3}>
                {vendor.description}
            </Text>
        </>
    );
};

const subHeaderStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
    mb: 4
});

const titleStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    mb: 3
});
